import { ComputedRef } from 'vue'

import { TestCase } from '@/domain/value_objects/testCase/TestCase'
import { TestCaseViewModel } from '@/presentation/viewmodels/testCase/testCaseViewModel'

export class TestCasePresenter {
  private viewModel: TestCaseViewModel

  constructor(viewModel: TestCaseViewModel) {
    this.viewModel = viewModel
  }

  get testCaseList(): ComputedRef<TestCase[]> {
    return this.viewModel.testCaseList
  }

  get isLoading(): ComputedRef<boolean> {
    return this.viewModel.isLoading
  }

  get error(): ComputedRef<string | null> {
    return this.viewModel.error
  }

  async getTestCaseList(problemId: string): Promise<void> {
    await this.viewModel.getTestCaseList(problemId)
  }
}
